export const RECURRENCE_SEARCH = "@recurrence/RECURRENCE_SEARCH";
export const RECURRENCE_SEARCH_RESET = "@recurrence/RECURRENCE_SEARCH_RESET";
export const SET_PAGE_NO = "@recurrence/SET_PAGE_NO";
export const SET_RECURRENCE = "@recurrence/SET_RECURRENCE";
export const SET_RECURRENCE_COUNT = "@recurrence/SET_RECURRENCE_COUNT";